











































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import KriteriaHcuSvc from "@/services/KriteriaHcuService";
import moment from "moment";

@Component({
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class KriteriaHcuKeluarSection extends Vue {
  @Prop() data!: any;
  @Prop() register!: string | number;
  @Prop() rm!: string | number;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  form: any = this.defaultForm();
  saving = false;
  signing = false;
  signDialog = false;
  signPassword = "";
  showPassword = false;
  signError = "";
  signRole = "";

  get isKeluarLocked() {
    return this.data?.is_keluar_locked || false;
  }

  get signRoleLabel() {
    return this.signRole === "ppja" ? "PPJA / PJ Shift" : "DPJP";
  }

  //  Cermin `KriteriaHcu::KRITERIA_KELUAR_FIELDS` + gerbang 422 `signChecklist*`.
  //  Diturunkan dari kunci `defaultForm()` supaya tidak ada daftar kedua yang
  //  bisa ketinggalan saat item blanko bertambah.
  get kriteriaCheckedCount(): number {
    return Object.keys(this.defaultForm()).filter(
      k => (k.startsWith("cl_") || k.startsWith("kk_")) && this.form[k] === true
    ).length;
  }

  get validationError(): string {
    //  Sekali dokumen ber-TTD, seluruh input terkunci sehingga kriteria tak bisa
    //  lagi dicentang — jangan halangi penanda tangan kedua (cermin pengecualian
    //  `!is_keluar_locked` pada gerbang 422 di server).
    if (this.isKeluarLocked) return "";
    if (this.kriteriaCheckedCount === 0) return "Minimal 1 kriteria keluar harus dicentang";
    return "";
  }

  //  Blanko RSPS revisi 30 Juli 2026 hal. 2-3 — I. Kriteria Umum (cl_*) lalu
  //  II. Kriteria Spesifik (kk_*). Urutan harus sama dengan blade PDF.
  //  Kolom di luar blanko (keluar_status/keluar_ruang_tujuan, seluruh kk_*_value,
  //  kk_catatan, cl_catatan, dan seluruh k_* Ringkasan Kondisi Klinis) sengaja
  //  tidak diikutkan di sini. `saveDraft()` mengirim `this.form` saja, sehingga
  //  kolom-kolom itu tidak pernah ikut terkirim dan nilainya di DB tidak tersentuh.
  defaultForm() {
    return {
      //  I. Kriteria Umum
      cl_hemodinamik_24jam: false,
      cl_spo2_stabil: false,
      cl_kesadaran_stabil: false,
      cl_no_monitoring_kontinu: false,
      cl_no_resusitasi_24jam: false,
      cl_no_syringe_pump: false,
      //  II. Kriteria Spesifik
      kk_vt_adekuat: false,
      kk_rr_normal: false,
      kk_spo2_gt95: false,
      kk_batuk_adekuat: false,
      kk_hr_normal: false,
      kk_td_normal: false,
      kk_map_normal: false,
      kk_non_inotropic: false,
      kk_akral_hangat: false,
      kk_urine_adekuat: false,
      kk_elektrolit_normal: false,
      kk_cvp_normal: false,
      kk_gcs_gt12: false,
      kk_tidak_kejang: false,
      kk_suhu_normal: false,
      kk_gdr_normal: false,
      kk_insulin_non_iv: false,
    };
  }

  @Watch("data", { immediate: true })
  onDataChange() {
    if (this.data) {
      this.populateForm();
    }
  }

  populateForm() {
    const d = this.data;
    Object.keys(this.form).forEach(key => {
      if (d[key] !== undefined && d[key] !== null) {
        this.form[key] = d[key];
      }
    });
  }

  formatDate(dt: string) {
    return dt ? moment(dt).format("DD/MM/YYYY HH:mm") : "-";
  }

  //  `silent` dipakai doSign(): tanpa itu simpan memancarkan "saved" sehingga induk
  //  mulai me-refresh SEBELUM TTD selesai, dan refresh pra-TTD itu bisa menimpa
  //  hasil refresh pasca-TTD sehingga status TTD tampak hilang sampai halaman dimuat ulang.
  async saveDraft(silent = false) {
    this.saving = true;
    try {
      if (this.data?.id) {
        const resp = await KriteriaHcuSvc.update(this.data.id, this.form);
        if (resp?.data?.status === "1") {
          appModule.NoticeDelay("Berhasil menyimpan kriteria keluar HCU");
          if (!silent) this.$emit("saved", resp.data.data);
        }
      }
    } catch (e) {
      // Error handled by service
    }
    this.saving = false;
  }

  openSignDialog(role: string) {
    this.signRole = role;
    this.signPassword = "";
    this.signError = "";
    this.signDialog = true;
  }

  async doSign() {
    if (!this.signPassword) {
      this.signError = "Password harus diisi";
      return;
    }

    this.signing = true;
    this.signError = "";

    try {
      //  Simpan isian terkini dulu; dilewati bila lembar sudah terkunci TTD pertama
      //  (update() akan ditolak 403 dan hanya menampilkan galat yang membingungkan).
      if (!this.isKeluarLocked) {
        await this.saveDraft(true);
      }

      const signFn = this.signRole === "ppja"
        ? KriteriaHcuSvc.signChecklistPpja
        : KriteriaHcuSvc.signChecklistDpjp;

      const resp = await signFn(this.data.id, {
        password: this.signPassword,
      });

      if (resp?.data?.status === "1") {
        appModule.NoticeDelay(`Berhasil menandatangani sebagai ${this.signRoleLabel}`);
        this.signDialog = false;
        this.$emit("signed");
      }
    } catch (e) {
      this.signError = "Gagal menandatangani. Periksa password Anda.";
    }

    this.signing = false;
  }
}
